// @sonar-ignore
import { css } from 'emotion';

export const inactive = css`
  pointer-events: none;
  cursor: auto;
`;

// fade effect
export const fadeEnter = css`
  opacity: 0;
`;

export const fadeEnterActive = css`
  opacity: 1;
`;

export const fadeLeave = css`
  ${inactive};
  opacity: 1;
`;

export const fadeLeaveActive = css`
  ${inactive};
  opacity: 0;
`;

// scale effect
export const scaleEnter = css`
  opacity: 0;
  transform: scale(0);
`;

export const scaleEnterActive = css`
  opacity: 1;
  transform: scale(1);
`;

export const scaleLeave = css`
  ${inactive};
  opacity: 1;
  transform: scale(1);
`;

export const scaleLeaveActive = css`
  ${inactive};
  opacity: 0;
  transform: scale(0);
`;

// transform effect
export const transformEnter = css`
  transform: translateY(150%);
  opacity: 0;
`;

export const transformEnterActive = css`
  transform: translateY(0);
  opacity: 1 !important;
`;

export const transformLeave = css`
  ${inactive};
  transform: translateY(0);
  opacity: 1 !important;
`;

export const transformLeaveActive = css`
  ${inactive};
  transform: translateY(150%);
  opacity: 0 !important;
`;

// up
export const transformUpEnter = transformEnter;
export const transformUpEnterActive = transformEnterActive;
export const transformUpLeave = transformLeave;
export const transformUpLeaveActive = transformLeaveActive;

// left
export const transformLeftEnter = css`
  transform: translateX(150%);
`;

export const transformLeftEnterActive = css`
  transform: translateX(0);
`;

export const transformLeftLeave = css`
  ${inactive};
  transform: translateX(0);
`;

export const transformLeftLeaveActive = css`
  ${inactive};
  transform: translateX(150%);
`;

// right
export const transformRightEnter = css`
  transform: translateX(-150%);
`;

export const transformRightEnterActive = css`
  transform: translateX(0);
`;

export const transformRightLeave = css`
  ${inactive};
  transform: translateX(0);
`;

export const transformRightLeaveActive = css`
  ${inactive};
  transform: translateX(-150%);
`;

// down
export const transformDownEnter = css`
  transform: translateY(-150%);
`;

export const transformDownEnterActive = css`
  transform: translateY(0);
`;

export const transformDownLeave = css`
  ${inactive};
  transform: translateY(0);
`;

export const transformDownLeaveActive = css`
  ${inactive};
  transform: translateY(-150%);
`;
